import { render, staticRenderFns } from "./TicketsWidgetPicker.vue?vue&type=template&id=64130872&"
import script from "./TicketsWidgetPicker.vue?vue&type=script&lang=js&"
export * from "./TicketsWidgetPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports